
export default {
    data() {
        return {
            filters: {
                technology: { value: '', available: value => true },
                power_mode: { value: '', available: value => true },
                ip_rating: { value: '', available: value => true },
                temperature: { value: false, available: () => true },
                humidity: { value: false, available: () => true },
                co2: { value: false, available: () => true },
                backlight: { value: false, available: () => true },
                color: { value: '', available: value => true }
            },
            selectedSku: null,
        };
    },

    computed: {
        filteredVariants() {
            const BOOL_KEYS = ['temperature', 'humidity', 'co2', 'backlight'];
            const FEAT_PROP = {
                temperature: 'has_temperature',
                humidity: 'has_humidity',
                co2: 'has_co2',
                backlight: 'has_backlight'
            };

            return Object.fromEntries(
                Object.entries(this.availableVariants)
                    .filter(([sku, variant]) => {
                        return Object.entries(this.filters).every(([key, filter]) => {
                            if (!filter.value) {
                                return true;
                            }
                            if (BOOL_KEYS.includes(key)) {
                                return variant[FEAT_PROP[key]] === filter.value;
                            }
                            return variant[key] === filter.value;
                        });
                    })
            );
        }
    },

    methods: {
        toggleFilter(key, value = null) {
            const filter = this.filters[key];

            if (typeof filter.available === 'function' && !filter.available(value)) {
                return;
            }

            if (value === null) {
                filter.value = !filter.value;
            }
            else {
                if (filter.value === value) {
                    filter.value = '';
                }
                else {
                    filter.value = value;
                }
            }

            this.updateFilterAvailability();
        },
        /**
           * Reset all filters to their default values and recalculate availability.
           */
        resetFilter() {
            Object.entries(this.filters).forEach(([key, filter]) => {
                if (typeof filter.value === 'boolean') {
                    filter.value = false;
                }
                else {
                    filter.value = '';
                }
            });

            this.updateFilterAvailability();
        },

        updateFilterAvailability() {
            const filters = this.filters;
            const variants = Object.values(this.availableVariants);

            function matchesAll(variant) {
                return Object.entries(filters).every(([key, filter]) => {
                    if (!filter.value) {
                        return true;
                    }
                    if (['temperature', 'humidity', 'co2', 'backlight'].includes(key)) {
                        return variant[`has_${key}`] === filter.value;
                    }
                    return variant[key] === filter.value;
                });
            }

            const possibleVariants = variants.filter(matchesAll);

            Object.entries(filters).forEach(([key, filter]) => {
                if (['temperature', 'humidity', 'co2', 'backlight'].includes(key)) {
                    filter.available = () => {
                        return possibleVariants.some(variant => variant[`has_${key}`] === true);
                    };
                }
                else {
                    const reachable = new Set(
                        possibleVariants.map(variant => variant[key])
                    );
                    filter.available = (value) => {
                        return reachable.has(value);
                    };
                }
            });

            //If the selected SKU is filtered out, reset it
            if (this.selectedSku && !possibleVariants.some(variant => variant.sku === this.selectedSku)) {
                this.selectedSku = null;
            }
        },

        /**
         * Returns CSS class for a filter option’s selector
         * @param {String} key
         * @param {*} value
         * @returns {String}
         */
        getVariantSelectorClass(key, value) {
            const filter = this.filters[key];

            if (typeof filter.available === 'function' && !filter.available(value)) {
                return 'tpf__variant--filter--item-selector--disabled';
            }

            if (filter.value === value || filter.value === true) {
                return 'tpf__variant--filter--item-selector--active';
            }

            return '';
        }
    },

    created() {
        this.updateFilterAvailability();
    }
};
